import { render, staticRenderFns } from "./PublicatorAuthDialog.vue?vue&type=template&id=7c6c6023&scoped=true"
import script from "./PublicatorAuthDialog.vue?vue&type=script&lang=js"
export * from "./PublicatorAuthDialog.vue?vue&type=script&lang=js"
import style0 from "./PublicatorAuthDialog.vue?vue&type=style&index=0&id=7c6c6023&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6c6023",
  null
  
)

export default component.exports